import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const TransformerMono = {
  id: "90",
  name: "Transformador",
  mainClass: "Estático",
  subtype: "Monofásico",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.electricalPower,
      unit: unitDefault.electricalPower.metric,
      code: "transformerElectricalPower"
    },
    {
      value: 0,
      type: unitTypes.voltage,
      unit: unitDefault.voltage.metric,
      code: "transformerPrimaryVoltage"
    },
    {
      value: 0,
      type: unitTypes.voltage,
      unit: unitDefault.voltage.metric,
      code: "transformerSecundaryVoltage"
    },
    {
      value: 0,
      type: unitTypes.electricCurrent,
      unit: unitDefault.electricCurrent.metric,
      code: "transformerPrimaryCurrent"
    },
    {
      value: 0,
      type: unitTypes.electricCurrent,
      unit: unitDefault.electricCurrent.metric,
      code: "transformerSecundaryCurrent"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "transformerWindingTemperature"
    },
    {
      value: 0,
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "transformerImpedance"
    },
    {
      value: 0,
      type: unitTypes.frequency,
      unit: unitDefault.frequency.metric,
      code: "transformerFrequency"
    }
  ]
};
